<template>
  <div class="book-list-view"> 
    <div class="header-view"> 
        <div class="header">
            <div class="header-item">
                <div class="header-item-info">
                    <p><b>欢迎您</b>{{userInfo.pemail || userInfo.pusername}}</p>
                    <ul>
                        <li class="text" @click="bookshelfActive">我的书架</li>
                        <li><img src="@/assets/main_navigation.png" alt=""></li>
                        <li class="text" @click="outLoginPopuIsShow = true">注销</li>
                        <li><img src="@/assets/main_navigation.png" alt=""></li>
                        <li class="text" @click="helpPopuIsShow = true">使用帮助</li>
                        <li><img src="@/assets/main_navigation.png" alt=""></li>
                        <li class="text" @click="aboutPopuIsShow = true">关于我们</li>
                    </ul>
                    <p></p>
                </div>
                <div class="header-item-seach">
                    <div class="seach-left">
                        <!-- <div class="seach-type">
                            <span>册名</span> 
                        </div> -->
                        <selectInput :value="seachType" :option="seachOption" @click="seachTitleActive"/>
                        <input type="text" v-model="seachInput">
                    </div>
                    <div class="seach-center" @click="seachGo">
                        <img src="@/assets/main_button_search_up.png" mode="" class="img"/>
                        <img src="@/assets/main_button_search_down.png" mode="" class="img-hover"/>
                    </div>
                    <div class="seach-right" @click="seachPopuIsShow = true">
                        <img src="@/assets/main_button_moresearch_up.png" mode="" class="img"/>
                        <img src="@/assets/main_button_moresearch_down.png" mode="" class="img-hover"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main">
        <div class="main-left" :style="{width:!navLeftIsShow?'0':'240px'}">
            <ul>
                <li v-for="(item,index) in navList" :key="index" :class="[navIndex===index?'active':'']" @click="navActive(item,index,index)">{{item.name}}</li>
            </ul>
            <div class="nav-view">
                <vue-scroll>
                    <tree :data="treeData" :treeProps="propsxxx" v-if="navIndex===0" @active="activeTreeItem"></tree> 

                    <div class="nav-view-list" v-if="navIndex===1">
                        <ol>
                            <li v-for="(item,index) in fromObj.from" :key="index" :class="[typeIndex===index?'active':'']" @click="navTypeActive(item,index)">{{item}}</li>
                        </ol>
                    </div>
                    <div class="nav-view-list" v-if="navIndex===2">
                        <ol>
                            <li v-for="(item,index) in fromObj.years" :key="index" :class="[typeIndex===index?'active':'']" @click="navTypeActive(item,index)">{{item}}</li>
                        </ol>
                    </div>
                </vue-scroll>
            </div>
            <div class="position-icon" @click="navLeftIsShow = !navLeftIsShow">
                <img src="@/assets/main_slither1_up.png" alt="" class="img" :class="[!navLeftIsShow?'active':'']">
                <img src="@/assets/newspapers_slither1_down.png" alt="" class="img-active" :class="[!navLeftIsShow?'active':'']">
            </div>
        </div>
        <div class="main-right" :class="[!navLeftIsShow?'active':'']">
            <bookTable @row-click="tableRowActive" :list="bookTableList" :page="page" :seachText="seachText"/>
            <div class="pagination-view">
                <el-pagination
                    :background="true" 
                    @current-change="handleCurrentChange"
                    :current-page.sync="page.currentPage"
                    :page-size="page.size"
                    layout="total , prev, pager, next, jumper"
                    :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>

    <popu-view title="我的书架" width="850" height="596" :mask="true" backImg="serach" :show="bookshelfPopuIsShow" @close="popuClose('bookshelf')">
        <div slot="content" class="popu-bookshelf">
            <div class="popu-bookshelf-top">
                <p v-if="userInfo.pemail">E-MAIL：{{userInfo.pemail}}</p>
                <p>姓名：{{userInfo.pname || userInfo.pcontact}} </p> 
                <p v-if="userInfo.punits">单位名称：{{userInfo.punits}}</p>
                <p>电话：{{userInfo.pphone}}</p>
                <p v-if="userInfo.pregtime">注册时间：{{userInfo.pregtime}}</p> 
                <p>开启时间：{{userInfo.popentime}}</p> 
                <p>有效期：{{userInfo.pdeadlinetime}}</p>
                <p></p><p></p><p></p><p></p><p></p>
            </div>
            <div class="popu-bookshelf-bottom">
                <!-- <vue-scroll> -->
                    <my-book :list="myBookList" @row-click="tableRowActive"/>
                <!-- </vue-scroll> -->
            </div>
        </div>
    </popu-view>
    <popu-view title="高级检索" width="690" height="490" :mask="true" backImg="serach" :show="seachPopuIsShow" @close="popuClose('seach')">
        <div slot="content" class="popu-seach"> 
            <gj-seach @click="seniorSeach"/>
        </div>
    </popu-view>
    <popu-view title="使用帮助" width="690" height="490" :mask="true" backImg="serach" :show="helpPopuIsShow" @close="popuClose('help')">
        <div slot="content" class="popu-help">
          <p>特别提示：<span><a href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank" >google浏览器</a></span>打开本数据库体验效果最好。</p>
          <p>本数据库针对单位用户进行设计，通过管理员在后台配置单位用户的IP范围，单位用户就可以自动登录，阅读下载本库内容。为方便个人用户测试，本库也提供个人用户注册机制。访问本库有二种方式，不同用户访问权限不一样。 </p>
          <p>1、已注册个人用户 </p>
          <p class="left-30">已经注册个人用户，并经管理员开通后，可以正常阅读本库的全部信息。 </p>
          <p>2、单位用户  </p>
          <p class="left-30">已开通的单位用户如果在IP段，可以自动登录。 </p>
          <p>技术支持 </p>
          <p>电话：010-66165618    66126178    13651224343（吴） </p>
          <p>QQ：26477072（吴）    646425467（齐）    178074936（刘） </p>
        </div>
    </popu-view>
    <popu-view title="关于我们" width="700" height="496" :mask="true" backImg="serach" :show="aboutPopuIsShow" @close="popuClose('about')">
        <div slot="content" class="popu-about">
          《中国艺术研究报刊专题库》产品，是基于了二十世纪中叶全国各大报刊、文艺专业期刊、各个省、地、市文化厅局内部刊物、建国后历届文艺汇演会刊，在这个海量资料信息基础上，以戏曲、话剧、音乐、美术、舞蹈、歌剧、曲艺、电影等各个艺术门类为纲，以剧种、剧目、表演、舞台美术、创作研究、文艺理论、文艺政策、史论研究等版块为目，以大量文章剪报为最基本元素物质基础，利用现代科技信息资源网络数据库的技术手段，将这批珍贵资源加工制作成《中国艺术研究报刊专题库》产品，以使从事艺术研究、艺术教学、艺术科研、文化传播的学者专家，非常顺利地检索出相关的史料文献，特别是避免了对单一课题相关文献检索过程中大海捞针式的繁缛劳动，譬如：现代戏《红灯记》的创作改编、音乐创新、舞台美术、表演探索、现代京剧艺术的创新，等等，又譬如：清官戏创作讨论、历史剧创作争鸣、京剧改革趋势，等等，都可以一库在手，按图索骥，搜索欲求。此外，由于使用了原版报刊影印技术，并标注报刊日期出处，以使读者在理论研究和教学工作中，可以直接使用相关数据作为引文，成为撰写文章的依据，不用再费力去翻阅过往报刊，避免了建国后图书馆报刊资源收藏短板、缺失、漫漶、难觅的困境。《中国艺术研究报刊专题库》是一个基于了文艺理论研究专业视角，并非常实用，非常专业的数据库产品，这种对报刊资源加工的模式，要远远优于其他报刊资源汇刊、汇编等纸质出版物，给读者一个切实可操作、可查询的工具型数据库。
        </div>
    </popu-view>

     <popu-view title="" width="400" height="290" :mask="true" backImg="serach" :show="outLoginPopuIsShow" @close="popuClose('outLogin')">
        <div slot="content" class="popu-out-login">
            <p>您确定要退出登录吗</p>
            <div class="popu-out-login-btn">
                <button @click="popuClose('outLogin')">取消</button>
                <button @click="outLodinFn">确定</button>
            </div>
        </div>
    </popu-view>
  </div>
</template>

<script>  
import tree from "@/components/tree/index.vue"
import bookTable from "@/components/bookTable/bookTable.vue"
import myBook from "@/components/bookTable/myBook.vue"
import popuView from "@/components/popuView.vue"
import selectInput from "@/components/selectInput/selectInput.vue"
import gjSeach from "@/components/gj-seach/gj-seach.vue"

import { navList , seachOption} from "./state"
import { 
         indexFrom , 
         indexYears , 
        //  indexClass , 
         indexBookclass,
         indexList,
         indexBag,
 } from "@/api/lxc/index"



export default {
  name: "home",
  data() {
    return {  
        navIndex:0,//左侧顶部 类别 出处 年代 index 
        typeIndex:0,//左侧年代 出处 点击某一项切换 
        navLeftIsShow:true,
        fromObj:{
            from:[],
            years:[]
        },
        bookTableList:[],
        propsxxx: {
          children: 'children',
          label: 'name'
        },
        treeData:[], 
        navList:navList,
        seachOption:seachOption, //普通搜索 - 下拉数据配置 
        loginViewIsShow:true,
        helpPopuIsShow:false,//使用帮助 弹框
        aboutPopuIsShow:false,//关于我们 弹框
        outLoginPopuIsShow:false,//是否要退出登录 再次确认弹框
        bookshelfPopuIsShow:false,//我的书架 弹框
        seachPopuIsShow:false,//高级搜索 弹框
        bookshelfData:[],//我的书架 数据
        seachType:seachOption[0],// 搜索框 左侧查询分类绑定 
        seachInput:"",//搜索框 数据
        page:{
            size:0,
            index:1,
            currentPage: 1,
            total:0
        },
        seachFrom:{ 
            allname:"",//全字段
            chaptername:"", // 册名
            publishdate:"", // 发布时间
            author:"", // 作者
            dfrom:"", // 出处
            bookName:"", // 书名
            className:"", // 类别名
            classid:"", // 类别id
            bookid:"", // 书id
        },
        myBookList:[],//我的书架
        seachText:""
    };
  },
  components:{ 
      tree,
      popuView,
      bookTable,
      myBook,
      selectInput,
      gjSeach
  },
  computed: { 
    userInfo(){
        return this.$store.state.userInfo
    }
  }, 
  created(){
      const mainHeight = this.getViewPortWidth() - 246 - 100  //main 盒子里 表格高度   
      this.page.size = parseInt(mainHeight / 35)

      this.getFrom()
      this.getYears()  
      this.getClassAll()

      this.getBookList()

      this.getMyBagList()
  },
  mounted(){
     
  },
  methods: { 
      /**
       * @description 高级搜索查询
      */
      seniorSeach(res){
        console.log(res)
        this.clearSeachFrom() 
        this.seachFrom={ 
            chaptername:this.filterTypeToVal(3,res), // 册名
            publishdate:this.filterTypeToVal(6,res), // 发布时间
            author:this.filterTypeToVal(4,res), // 作者
            dfrom:this.filterTypeToVal(5,res), // 出处
            bookName:this.filterTypeToVal(2,res) , // 书名
            className:this.filterTypeToVal(7,res), // 类别名
            classid:"", // 类别id
            bookid:"", // 书id
        }
        this.seachPopuIsShow = false
        this.page.index = 1
        this.page.currentPage = 1
        this.getBookList()
      },
      filterTypeToVal(type,list){
          return list.find(item=>{
              return item.type === type
          }).val
      },
      /**
       * @description 普通 搜索查询
      */
      seachGo(){ 
          if(this.seachInput.length === 0) return
          this.clearSeachFrom()
          const { type } = this.seachType
          if(type ===1) this.seachFrom.allname = this.seachInput  //全字段
          if(type ===2) this.seachFrom.bookName = this.seachInput  //册名
          if(type ===3) this.seachFrom.chaptername = this.seachInput  //篇名
          if(type ===4) this.seachFrom.author = this.seachInput  //著译者
          if(type ===5) this.seachFrom.dfrom = this.seachInput  //出处
          
          this.page.index = 1
          this.page.currentPage = 1
          this.seachText = this.seachInput
          this.getBookList()
      },
      /**
       * @description 点击搜索框左侧 选择查询分类回掉
       * @param res.item 选择的项
       * @param res.index 选择的第几个
      */
      seachTitleActive(res){
          const { item } = res 
          this.seachType = item
      },
      /**
       * @deprecated 我的书架 显示弹框，调用书架接口 并渲染
      */
      bookshelfActive(){
          this.getMyBagList()
          this.bookshelfPopuIsShow = true
      },
      /**
       * @deprecated 表格某一行被点击时处发的事件儿 res.data = 当前行的数据
      */
      tableRowActive(res){
          const { data } = res
          console.log(data)
          this.$router.push({
              name:"detail",
              query:{
                  chapterid:data.chapterid || 0,
                  bookid:data.bookid
              }
            })
      },
      /**
       * @deprecated 重置搜索查询条件 
      */
      clearSeachFrom(){
        this.seachFrom={ 
            allname:"",//全字段
            chaptername:"", // 册名
            publishdate:"", // 发布时间
            author:"", // 作者
            dfrom:"", // 出处
            bookName:"", // 书名
            className:"", // 类别名
            classid:"", // 类别id
            bookid:"", // 书id
        }
      },
      navTypeActive(item,index){
          this.typeIndex = index  
           this.seachText = ''
          if(this.navIndex === 1){ 
            this.clearSeachFrom() 
            this.seachFrom.dfrom = this.fromObj.from[index] 
          }
          if(this.navIndex === 2){
            this.clearSeachFrom()  
            this.seachFrom.publishdate = this.fromObj.years[index]
          }

          this.page.index = 1
          this.page.currentPage = 1
          this.getBookList()
      }, 
      /**
       * @deprecated 点击 左侧树形菜单
       * @param item 当前的详细信息
      */
      activeTreeItem(item){
          const { level } = item 
          this.clearSeachFrom()   
          this.seachText = ''
          this.seachFrom.classid = level
          this.page.index = 1
          this.page.currentPage = 1
          this.getBookList()
          
      },
      navActive(item,index){
          if(this.navIndex === index) return
          this.navIndex = index 
          this.typeIndex = null
      }, 
      /**
       * @deprecated 点击分页
       * @param val 当前第几页
      */
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.page.index = val
        this.getBookList()
      },
      /**
       * @deprecated 弹框关闭
       * @param type help:帮助弹框
      */
      popuClose(type){
          switch(type){
                case 'help' :
                  this.helpPopuIsShow = false
                    break;
                case 'about' :
                  this.aboutPopuIsShow = false
                    break;
                case 'outLogin' :
                    this.outLoginPopuIsShow = false
                    break;
                case 'bookshelf':
                    this.bookshelfPopuIsShow = false
                    break;
                case 'seach':
                    this.seachPopuIsShow = false
                    break;
              default:

          }
      },
      //获取书架 列表
      async getMyBagList(){
          const { code , bookbagDtos } = await indexBag()
          if(code === 0){
            console.log(code)
            this.myBookList=bookbagDtos
          }else{
            console.log(code)
          }
      },
      //bookTableList 获取列表
      async getBookList (){
          const { chaptername , publishdate , author , dfrom , bookName , className , classid , bookid , allname } = this.seachFrom
          const {page , code} = await indexList({
              page: this.page.index,
              limit:this.page.size,
              chaptername, // 册名
              publishdate, // 发布时间
              author, // 作者
              dfrom, // 出处
              bookName, // 书名
              className, // 类别名
              classid, // 类别id
              bookid, // 书id
              allname,
          })

          if(code === 0){
            this.bookTableList = page.list
            this.page.total =  page.totalCount
          }else{
            this.bookTableList = []
            this.page.total =  0
          }
        //   console.log(page)
      },
      //获取类别 all
      async getClassAll(){
          const page = await indexBookclass({
              page: 1,
              limit:10000,
          }) 
          this.$utils.getClassTree(page.list).then(res=>{  
              this.treeData = res.list
          })
      },
      //根据父级ID 获取类别 弃用
    //   async getClass(){
        //   const from = await indexClass({id:"0"}) 
        //   console.log(from)
        //   this.fromObj.from = from.filter(item =>{
        //       return item!=="" && item!=="string" && item!=null 
        //   })
    //   },
      //获取出处 all
      async getFrom(){
          const {from} = await indexFrom() 
          this.fromObj.from = from.filter(item =>{
              return item!=="" && item!=="string" && item!=null 
          })
      },
      //获取年份 all
      async getYears(){
          const {years} = await indexYears() 
          this.fromObj.years = years.filter(item =>{
              return item!=="" && item!=="string" && item!=null 
          })
      },
      /**
       * @deprecated 退出系统
      */
      outLodinFn(){ 
          this.$router.replace({name:"home"})
          this.$store.commit("setUserInfo",{})
          this.$cookies.remove("token")
      },
      getViewPortWidth() {
        return document.documentElement.clientHeight || document.body.clientHeight;
      }
  }
};
</script>
<style>
.book-list-view .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #362f29;
    color: #FFF;
} 
.book-list-view .el-pagination.is-background .el-pager li:hover { 
    color: #a19183; 
}
.popu-bookshelf .popu-title{
    padding: 10px 0 0 0!important;
}
.el-pagination__total{
    color: red!important;
}
</style>
<style scoped lang="less"> 
@import "./bookList.less";
</style>
